import React, { useState } from "react";

const Languages = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [languages, setLanguages] = useState({
    motherTongue: "English",
    professionalLevel: "Fluent",
    writingProficiency: "Advanced",
  });

  return (
    <div className="flex flex-col w-full mr-11 bg-white rounded-3xl mt-4 h-full">
      <div className="flex justify-between items-center">
        <h1 className="font-bold text-xl m-3 ml-7 mt-4">Languages</h1>
        <button
          className="text-xl m-3 mr-7 text-blue-600 focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? "▲" : "▼"}
        </button>
      </div>
      {isOpen && (
        <div className="grid grid-cols-3 gap-6 m-10 mt-4">
          <legend className="text-gray-500">
            Mother Tongue <br />
            {isEditing ? (
              <input
                type="text"
                value={languages.motherTongue}
                onChange={(e) =>
                  setLanguages({ ...languages, motherTongue: e.target.value })
                }
                className="border rounded p-2 w-full"
              />
            ) : (
              <span className="text-black font-semibold">
                {languages.motherTongue || "Not Provided"}
              </span>
            )}
          </legend>
          <legend className="text-gray-500">
            Professional Level <br />
            {isEditing ? (
              <input
                type="text"
                value={languages.professionalLevel}
                onChange={(e) =>
                  setLanguages({
                    ...languages,
                    professionalLevel: e.target.value,
                  })
                }
                className="border rounded p-2 w-full"
              />
            ) : (
              <span className="text-black font-semibold">
                {languages.professionalLevel || "Not Provided"}
              </span>
            )}
          </legend>
          <legend className="text-gray-500">
            Writing Proficiency <br />
            {isEditing ? (
              <input
                type="text"
                value={languages.writingProficiency}
                onChange={(e) =>
                  setLanguages({
                    ...languages,
                    writingProficiency: e.target.value,
                  })
                }
                className="border rounded p-2 w-full"
              />
            ) : (
              <span className="text-black font-semibold">
                {languages.writingProficiency || "Not Provided"}
              </span>
            )}
          </legend>
        </div>
      )}
      {isOpen && (
        <div className="flex mt-4">
          <button
            onClick={() => setIsEditing(!isEditing)}
            className={`ml-10 mb-4 px-4 py-2 rounded ${
              isEditing
                ? "bg-gray-600 text-white"
                : "bg-[#0077af] text-white hover:bg-[#005e87]"
            }`}
          >
            {isEditing ? "Cancel Edit" : "Edit"}
          </button>
        </div>
      )}
    </div>
  );
};

export default Languages;
